import React from 'react';
import { ReactComponent } from 'Common/components/Icons/topics.svg';

const Topics = () => <ReactComponent className="MuiSvgIcon-root" />;

export default Topics;
